import { useParams, useNavigate } from "react-router-dom";
import { api } from "../../utils/apiClient";
import { toast } from "react-toastify";
import { useState, useEffect } from "react";
import ContentLoader from "../../utils/ContentLoader";
import ArticleForm from "../../components/forms/ArticleForm";

export default function ArticleFormPage() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [initialData, setInitialData] = useState({});
    const [articleTypeOptions, setArticleTypeOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    // =========================
    // FETCH ARTICLE (EDIT)
    // =========================
    useEffect(() => {
        if (id) {
            const fetchArticle = async () => {
                try {
                    setLoading(true);

                    const res = await api.get(`/articles/${id}`);

                    if (!res.data.status) {
                        toast.error(res?.data?.message || "Failed to fetch article");
                        return;
                    }

                    setInitialData(res.data.data);
                } catch (err) {
                    toast.error(
                        err?.response?.data?.message || "Something went wrong"
                    );
                    navigate("/articles");
                } finally {
                    setLoading(false);
                }
            };

            fetchArticle();
        }
    }, [id]);

    // =========================
    // FETCH ARTICLE TYPES
    // =========================
    useEffect(() => {
        fetchArticleTypes();
    }, []);

    const fetchArticleTypes = async () => {
        try {
            const res = await api.get("/article-types");

            const options = res.data.data.map((item) => ({
                value: item.id,
                label: item.name
                    .split("_")
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(" "),
            }));

            setArticleTypeOptions(options);
        } catch (err) {
            console.error("Failed to fetch article types", err);
        }
    };

    // =========================
    // SUBMIT
    // =========================
    const handleSubmit = async (formData) => {
        try {
            setLoading(true);

            if (id) {
                await api.post(`/articles/update/${id}`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });

                toast.success("Article updated successfully");
            } else {
                await api.post("/articles", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });

                toast.success("Article created successfully");
            }

            navigate("/articles");
        } catch (err) {
            const errorMessage =
                Object.values(err?.response?.data?.errors || {})?.[0]?.[0] ||
                err?.response?.data?.message ||
                "Something went wrong";

            toast.error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <ContentLoader />;

    return (
        <ArticleForm
            onSubmit={handleSubmit}
            onCancel={() => navigate("/articles")}
            initialData={initialData}
            articleTypeOptions={articleTypeOptions}
        />
    );
}